import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Banner.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Banner = ({ data, bannerType }) => {
  if (!data || data.length === 0) return null;

  const CustomPrevArrow = (props) => {
    const { style, onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          backgroundColor: "#D3D3D3",
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          left: "10px",
          zIndex: 1,
          cursor: "pointer",
        }}
      >
        <FaChevronLeft style={{ color: "white", fontSize: "24px" }} />
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          backgroundColor: "#D3D3D3",
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "10px",
          zIndex: 10,
          cursor: "pointer",
        }}
      >
        <FaChevronRight style={{ color: "white", fontSize: "24px" }} />
      </div>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <section className={`banner ${bannerType === "Banner2" ? "banner-2" : ""}`}>
      <Slider {...settings}>
        {data.map((item, index) => (
          <div key={index} className="banner-slide">
            <a
              href={item.link || "#"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={item.image} alt={item.title} className="banner-image" />
            </a>
          </div>
        ))}
      </Slider>
    </section>
  );
};

Banner.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      buttonText: PropTypes.string,
      buttonLink: PropTypes.string,
      link: PropTypes.string, // New property for linking banners
    })
  ),
  bannerType: PropTypes.string,
};

export default Banner;
